import { render, staticRenderFns } from "./mallGoodsOrder.vue?vue&type=template&id=f5a30346&scoped=true&"
import script from "./mallGoodsOrder.vue?vue&type=script&lang=js&"
export * from "./mallGoodsOrder.vue?vue&type=script&lang=js&"
import style0 from "./mallGoodsOrder.vue?vue&type=style&index=0&id=f5a30346&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a30346",
  null
  
)

export default component.exports